<div class="simple-toast" [@openClose]="state" [ngStyle]="{ 'margin-top': margin }">
  <rb-notification-bar [type]="type">
    {{ label }}
  </rb-notification-bar>
</div>